import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DatePickerInput,
  Form,
  PLATFORM_THEME_COLORS,
  SwitchInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { StyledSwitchButtonContainer, StyledSwitchContainer } from './with-switcher-fields.styles';
import { FormInstance } from 'antd';

const WithSwitcherFields = ({
  fieldName,
  switcherName,
  form,
}: {
  fieldName?: string;
  switcherName?: string;
  form: FormInstance;
}) => {
  const { t, i18n } = useTranslation('employee');

  const defaultToggle = switcherName ? form.getFieldValue(['paymentAndInsurance', switcherName]) : false

  const [toggle, setToggle] = useState<boolean>(defaultToggle);

  return (
    <Fragment>
      {fieldName && switcherName && (
        <StyledSwitchContainer>
          <StyledSwitchButtonContainer>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {t(`paymentAndInsurance.labels.${switcherName}`)}:
            </Typography>
            <Form.Item
              valuePropName="checked"
              className={'switcher-field'}
              name={['paymentAndInsurance', switcherName]}
              label={''}
            >
              <SwitchInput
                defaultChecked={toggle}
                checkedChildren={t('common:labels.yes')}
                size={'small'}
                unCheckedChildren={t('common:labels.no')}
                onChange={checked => {
                  setToggle(checked);
                }}
              />
            </Form.Item>
          </StyledSwitchButtonContainer>
          {toggle && (
            <Form.Item
              name={['paymentAndInsurance', fieldName]}
              label={t(`paymentAndInsurance.labels.${fieldName}`)}
              rules={[{ required: toggle, message: t('customers:error.fieldIsRequired') }]}
            >
              <DatePickerInput lang={i18n.language} format="DD.MM.YYYY" />
            </Form.Item>
          )}
        </StyledSwitchContainer>
      )}
    </Fragment>
  );
};

export default WithSwitcherFields;
